import React, { HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

interface ProseProps extends HTMLAttributes<HTMLDivElement> {}

export const Prose = ({ children, className, ...rest }: ProseProps) => {
  const _className = twMerge(
    'prose max-w-none prose-h1:text-secondary prose-h1:font-medium prose-strong:text-primary',
    className,
  )

  return (
    <div className={_className} {...rest}>
      {children}
    </div>
  )
}
